import { get_depositConfig } from "@/api/xt4/wallet";
import { makeAutoObservable, observable } from "mobx";

export enum BreakpointEnum {
  xl = "xl", //超大屏幕，以 1698px 做设计，≥ 1698px
  lg = "lg", //正常屏幕，以 1400px 做设计， 1200px < normal < 1698px
  md = "md", //稍小屏幕，以 1020px 做设计， 768px < md ≤ 1200px
  sm = "sm", //移动端屏幕，以 375px 做设计，≤ 768px
}

export enum ClsUpDownEnum {
  up = "up-color", //上涨样式
  down = "down-color", //下跌样式
}

export enum ThemeEnum {
  light = "light", //浅色主题
  dark = "dark", //深色主题
}

export enum ColorStyleEnum {
  normal = 0, //默认，绿涨红跌
  reverse = 1, //相反，红涨绿跌
}

interface StateProps {
  clientSideReady: boolean;
  theme: ThemeEnum;
  colorStyle: ColorStyleEnum;
  breakpoint: BreakpointEnum;
  isPasskeySupport: WithUndefined<boolean>;
  depositConfig: ObjAny | undefined;
}

const app = makeAutoObservable(
  {
    clientSideReady: false as StateProps["clientSideReady"], //客户端是否就绪
    theme: ThemeEnum.dark as StateProps["theme"], //当前主题，默认深色主题
    colorStyle: ColorStyleEnum.normal as StateProps["colorStyle"], //颜色样式，默认绿涨红跌
    breakpoint: BreakpointEnum.lg as StateProps["breakpoint"], //屏幕尺寸断点
    isPasskeySupport: undefined as StateProps["isPasskeySupport"], //设备是否支持passkey
    depositConfig: undefined as StateProps["depositConfig"],

    get isDark(): boolean {
      return this.theme === ThemeEnum.dark;
    }, //是否是深色主题
    get isColorReverse(): boolean {
      return this.colorStyle == ColorStyleEnum.reverse;
    }, //颜色样式是否相反，红涨绿跌
    get isH5(): boolean {
      return this.breakpoint === BreakpointEnum.sm;
    }, //是否是H5布局

    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },

    async getDepositConfig() {
      if (!this.depositConfig) {
        let res = await get_depositConfig();
        if (res.depositSwitchLimit == undefined || res.withdrawSwitchLimit == undefined) {
          res = { ...res, depositSwitchLimit: true, withdrawSwitchLimit: true };
        }
        this.depositConfig = res;
        return res;
      }
      return this.depositConfig;
    },

    //
    initPasskey() {
      if (this.isPasskeySupport !== undefined) return;

      if (window.navigator && window.navigator.credentials) {
        this.isPasskeySupport = true;
      } else {
        this.isPasskeySupport = false;
      }

      /*
      if (window.PublicKeyCredential) {
        PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
          .then((available) => {
            if (available) {
              this.isPasskeySupport = true;
              console.log("【Passkey Support】");
            } else {
              this.isPasskeySupport = false;
              console.log("【WebAuthn supported, Platform Authenticator *not* supported.】");
            }
          })
          .catch((err) => console.log("Something went wrong."));
      } else {
        this.isPasskeySupport = false;
        console.log("【Passkey Not Support】");
      }
       */
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default app;
